import { useNavigate } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import { deleteMujjalah, getMujjalahs } from "./.request";
import { useAuth } from "../context/AuthContext";
import { IMAGE_URL } from "../constants/Consts";

const Mujjalah = () => {
    const navigate = useNavigate();
    const [mujjalahs, setMujjalahs] = useState([]);
    const { authToken, themeMode } = useAuth();
    const isDark = themeMode === 'dark';
    const IMAGE_SHOW = `${IMAGE_URL}mujjalahImages`;
    
    const getMujjalahList = useCallback(async () => {
        try {
            const response = await getMujjalahs(authToken);
            if (response.Result) {
                setMujjalahs(response.Mujjalahs || []);
            } else {
                console.error("Failed to fetch mujjalahs:", response.Msg);
            }
        } catch (error) {
            console.error("Error fetching mujjalahs:", error);
        }
    }, [authToken]);

    useEffect(() => {
        getMujjalahList();
    }, [authToken, getMujjalahList]);

    const handleEditMujjalah = (mujjalahId) => {
        navigate('/mujjalah/editMujjalah', { state: { mujjalahId } });
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this Mujjalah issue?")) return;
        try {
            const response = await deleteMujjalah(authToken, id);
            if (response.Result) {
                alert('Mujjalah Deleted');
                getMujjalahList();
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="space-y-6 pb-8">
            {/* Header */}
            <div className="glass-panel p-6 flex justify-between items-center">
                <div>
                    <h1 className={`font-extrabold text-2xl sm:text-3xl ${isDark ? 'text-white' : 'text-slate-900'}`}>Mujjalah Magazine</h1>
                    <p className={`text-xs mt-1 ${isDark ? 'text-slate-400' : 'text-slate-500'}`}>Manage Mujjalah magazine issues, publications, and covers</p>
                </div>
                <button
                    onClick={() => navigate('/mujjalah/createMujjalah')}
                    className="glass-btn-primary px-5 py-2.5 text-xs font-semibold"
                >
                    + Add Mujjalah
                </button>
            </div>

            {/* Mujjalah Table */}
            <div className="glass-panel overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full min-w-full glass-table">
                        <thead>
                            <tr>
                                <th className="py-3.5 px-4 text-center font-semibold text-xs uppercase tracking-wider">Cover</th>
                                <th className="py-3.5 px-4 text-center font-semibold text-xs uppercase tracking-wider">Year / Edition</th>
                                <th className="py-3.5 px-4 text-center font-semibold text-xs uppercase tracking-wider">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {mujjalahs.length > 0 ? (
                                mujjalahs.map((mujjalah) => (
                                    <tr key={mujjalah.id || mujjalah._id} className="transition-colors hover:bg-white/5">
                                        <td className="py-3.5 px-4 text-center">
                                            <div className="flex justify-center items-center">
                                                {mujjalah.image ? (
                                                    <img 
                                                        src={`${IMAGE_SHOW}/${mujjalah.image}`} 
                                                        alt="Cover" 
                                                        className="w-24 h-16 object-cover rounded-lg border border-white/10 shadow-sm" 
                                                    />
                                                ) : (
                                                    <div className="w-24 h-16 rounded-lg bg-slate-800/60 border border-white/10 flex items-center justify-center text-xs text-slate-500">No Image</div>
                                                )}
                                            </div>
                                        </td>
                                        <td className="py-3.5 px-4 text-center text-xs font-mono font-bold text-purple-400">{mujjalah.year}</td>
                                        <td className="py-3.5 px-4 text-center">
                                            <div className="flex items-center justify-center space-x-2">
                                                <button 
                                                    className="glass-btn-secondary px-4 py-1.5 text-xs font-medium"
                                                    onClick={() => handleEditMujjalah(mujjalah.id)}
                                                >
                                                    View / Edit
                                                </button>
                                                <button 
                                                    className="glass-btn-danger px-4 py-1.5 text-xs font-medium"
                                                    onClick={() => handleDelete(mujjalah.id)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="py-8 text-center text-sm text-slate-400">No mujjalahs found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default Mujjalah;
